import { useState } from "react";
import i18n from '../i18n';
import axios from 'axios';
import { API_CONFIG } from '../apis/api-config';
import { refreshToken } from "../hooks/useAuth";
import { 
  ENGLISH_FORM_CONFIGS, 
  NORWEGIAN_FORM_CONFIGS, 
  FormFieldConfig 
} from '../services/asset/asset-models';

let currentFormConfigs: Record<string, FormFieldConfig[]> = ENGLISH_FORM_CONFIGS;
let currentLanguage: string = 'en-US';

// Get current form configs (use this in your components)
export const getCurrentFormConfigs = (): Record<string, FormFieldConfig[]> => {
    return currentFormConfigs;
};

